import { MappedModule } from "../types/index";

export const MODULES: MappedModule = {
  "visualization": {
    title: "Painel de Consulta - Conexão Povos da Floresta",
    sidenavTitle: "Painel de Consulta",
    browserTitle: "Painel de Consulta",
    route: "/consulta"
  },
  "registro": {
    title: "Registro e Controle",
    sidenavTitle: "Registro e Controle",
    browserTitle: "Registro e Controle",
    route: "/registro"
  },
  "access-control": {
    title: "Usuários",
    sidenavTitle: "Configurações",
    browserTitle: "Configurações",
    route: "/admin"
  },
  "logistica": {
    title: "Logística",
    sidenavTitle: "Logística",
    browserTitle: "Logística",
    route: "/logistica"
  },
  "details": {
    title: "Detalhes da Comunidade",
    sidenavTitle: "Comunidade",
    browserTitle: "Comunidade",
    route: "/details/:communityId"
  }
};
